module.exports = __webpack_public_path__ + "img/cq.3b94c5a1.png";